import React, { useState } from "react";
import axios from "axios";

import "./index.css";
import Result from "./Result";
import Giphy from "./Giphy";

export default function Search() {
  let [keyword, setKeyword] = useState("");
  let [result, setResult] = useState({});
  let [giphy, setGiphy] = useState({});
  let [loaded, setLoaded] = useState("start");

  function search(event) {
    event.preventDefault();
    setLoaded("loading");

    function handleGiphyResponse(response) {
      console.log("sucess", response.data.data);
      setGiphy(response.data.data);
    }

    function handleDictionaryResponse(response) {
      setResult(response.data);
      setLoaded("loaded");
    }

    let dictionaryApiKey = "faf1t205ab1o74d732b54981fbc56c80";
    let dictionaryApiUrl = `https://api.shecodes.io/dictionary/v1/define?word=${keyword}&key=${dictionaryApiKey}`;

    axios.get(dictionaryApiUrl).then(handleDictionaryResponse);

    let giphyApiKey = "3TVUqfD23YeW011ypsMqvDP5Opcx6EFV";
    let giphyApiUrl = `https://api.giphy.com/v1/gifs/search?api_key=${giphyApiKey}&q=${keyword}&limit=10&rating=pg`;

    axios.get(giphyApiUrl).then(handleGiphyResponse);
  }

  function updateKeyword(event) {
    setKeyword(event.target.value);
  }

  let Search = (
    <header className="header">
      <h1>What word do you want to look up?</h1>
      <div className="search-box">
        <form onSubmit={search}>
          <input type="text" className="form-input" onChange={updateKeyword} />
          <input type="submit" className="form-submit" />
        </form>
      </div>
    </header>
  );

  if (loaded === "loaded") {
    return (
      <div>
        {Search}
        <Result result={result} />
        <Giphy giphy={giphy} />
      </div>
    );
  } else if (loaded === "loading") {
    return <div>{Search}</div>;
  } else if (loaded === "start") {
    return <div>{Search}</div>;
  }
}
